import "./styles.css";
import CustomContentHeaderWidget from "../CustomContentHeaderWidget";

/**
 * @function ContentSubheaderView
 * @param {STRING} className - CSS selectors to append.
 * @param {STRING} text - Sets the text.
 * @param {STRING} data-point - Sets a data point.
 * @returns {React.Component}
 * @description A component shown beneath comp id "ContentHeaderView" typically.
 * Example in comp id "CHW23Page".
 * @example
 * <ContentSubheaderView className="some-class" text="Content subheader text" />
 */
export default function ContentSubheaderView(props) {
  const className = props.className ?? "";
  const text = props.text ?? "" ;
  const point = props["data-point"] ?props["data-point"] : props.dataPoint ?? "";
  const widget = <CustomContentHeaderWidget content = { text } />;

  return (
    <div className={ `${ className } content-subheader` } >
      <span data-point={ point }>{ widget }</span>
    </div>
  );
}